<mat-sidenav-container class="sidenav-container" [class.loading]="isLoading">
    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <mat-spinner diameter="60"></mat-spinner>
        <p class="loading-text">Loading settings...</p>
    </div>

    <!-- Sidenav -->
    <mat-sidenav #sidenav mode="side" [opened]="!sidebarService.isSmallScreen" class="sidenav">
        <div class="sidenav-content">
            <!-- Logo Section -->
            <div class="logo-section">
                <div class="logo-wrapper">
                    <img class="logo" src="assets/img/qm_logo.jpeg" alt="QM Logo">
                </div>
            </div>

            <!-- Navigation Menu -->
            <nav class="nav-menu">
                <div class="nav-section">
                    <span class="nav-section-title">Main Menu</span>

                    <!-- Dashboard -->
                    <a class="nav-item" [class.active]="link === '/home/dashboard'"
                        (click)="navigateToComponent('/home/dashboard')">
                        <div class="nav-item-icon">
                            <mat-icon>dashboard</mat-icon>
                        </div>
                        <span class="nav-item-text">Dashboard</span>
                    </a>

                    <!-- User Management -->
                    <a class="nav-item" [class.active]="link === '/home/user-management'"
                        (click)="navigateToComponent('/home/user-management')">
                        <div class="nav-item-icon">
                            <mat-icon>manage_accounts</mat-icon>
                        </div>
                        <span class="nav-item-text">User Management</span>
                    </a>

                    <!-- Customer Management -->
                    <a class="nav-item" [class.active]="link === '/home/customer-management'"
                        (click)="navigateToComponent('/home/customer-management')">
                        <div class="nav-item-icon">
                            <mat-icon>business</mat-icon>
                        </div>
                        <span class="nav-item-text">Customer Management</span>
                    </a>

                    <!-- Consignee Registration -->
                    <a class="nav-item" [class.active]="link === '/home/consignee-registration'"
                        (click)="navigateToComponent('/home/consignee-registration')">
                        <div class="nav-item-icon">
                            <mat-icon>person_add</mat-icon>
                        </div>
                        <span class="nav-item-text">Consignee Registration</span>
                    </a>
                </div>

                <div class="nav-section">
                    <span class="nav-section-title">Operations</span>

                    <!-- Shipping Order -->
                    <mat-expansion-panel class="nav-expansion">
                        <mat-expansion-panel-header class="nav-expansion-header">
                            <mat-panel-title>
                                <div class="nav-item-icon">
                                    <mat-icon>local_shipping</mat-icon>
                                </div>
                                <span class="nav-item-text">Shipping Order</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="nav-submenu">
                            <a class="nav-subitem" [class.active]="link === '/home/shipping-order/order-tracking'"
                                (click)="navigateToComponent('/home/shipping-order/order-tracking')">
                                <span class="subitem-dot"></span>
                                <span>Order Tracking</span>
                            </a>
                            <a class="nav-subitem" [class.active]="link === '/home/booking-list'"
                                (click)="navigateToComponent('/home/booking-list')">
                                <span class="subitem-dot"></span>
                                <span>Booking List</span>
                            </a>
                        </div>
                    </mat-expansion-panel>

                    <!-- Fleet Management -->
                    <mat-expansion-panel class="nav-expansion">
                        <mat-expansion-panel-header class="nav-expansion-header">
                            <mat-panel-title>
                                <div class="nav-item-icon">
                                    <mat-icon>directions_car</mat-icon>
                                </div>
                                <span class="nav-item-text">Fleet Management</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="nav-submenu">
                            <a class="nav-subitem" [class.active]="link === '/home/truck-profile'"
                                (click)="navigateToComponent('/home/truck-profile')">
                                <span class="subitem-dot"></span>
                                <span>Truck Profile</span>
                            </a>
                            <a class="nav-subitem" [class.active]="link === '/home/driver-profile'"
                                (click)="navigateToComponent('/home/driver-profile')">
                                <span class="subitem-dot"></span>
                                <span>Driver Profile</span>
                            </a>
                            <a class="nav-subitem" [class.active]="link === '/home/transport-management'"
                                (click)="navigateToComponent('/home/transport-management')">
                                <span class="subitem-dot"></span>
                                <span>Transport Management</span>
                            </a>
                        </div>
                    </mat-expansion-panel>
                </div>

                <div class="nav-section">
                    <span class="nav-section-title">Finance & Reports</span>

                    <!-- Report -->
                    <a class="nav-item" [class.active]="link === '/home/report'"
                        (click)="navigateToComponent('/home/report')">
                        <div class="nav-item-icon">
                            <mat-icon>assessment</mat-icon>
                        </div>
                        <span class="nav-item-text">Report</span>
                    </a>

                    <!-- Accounting -->
                    <a class="nav-item" [class.active]="link === '/home/accounting'"
                        (click)="navigateToComponent('/home/accounting')">
                        <div class="nav-item-icon">
                            <mat-icon>account_balance</mat-icon>
                        </div>
                        <span class="nav-item-text">Accounting</span>
                    </a>
                </div>

                <div class="nav-section">
                    <span class="nav-section-title">Configuration</span>

                    <!-- Settings -->
                    <mat-expansion-panel class="nav-expansion">
                        <mat-expansion-panel-header class="nav-expansion-header">
                            <mat-panel-title>
                                <div class="nav-item-icon">
                                    <mat-icon>settings</mat-icon>
                                </div>
                                <span class="nav-item-text">Settings</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="nav-submenu">
                            <a class="nav-subitem" [class.active]="link === '/home/settings/user-settings'"
                                (click)="navigateToComponent('/home/settings/user-settings')">
                                <span class="subitem-dot"></span>
                                <span>User Settings</span>
                            </a>
                            <a class="nav-subitem" [class.active]="link === '/home/settings/truck-settings'"
                                (click)="navigateToComponent('/home/settings/truck-settings')">
                                <span class="subitem-dot"></span>
                                <span>Truck Settings</span>
                            </a>
                            <a class="nav-subitem" [class.active]="link === '/home/settings/customer-settings'"
                                (click)="navigateToComponent('/home/settings/customer-settings')">
                                <span class="subitem-dot"></span>
                                <span>Customer Settings</span>
                            </a>
                            <a class="nav-subitem" [class.active]="link === '/home/settings/report-predefind-data'"
                                (click)="navigateToComponent('/home/settings/report-predefind-data')">
                                <span class="subitem-dot"></span>
                                <span>Predefined Report</span>
                            </a>
                        </div>
                    </mat-expansion-panel>
                </div>
            </nav>

            <!-- User Profile Card at Bottom -->
            <!-- <div class="sidenav-footer">
                <div class="user-card" [matMenuTriggerFor]="sidenavProfileMenu">
                    <div class="user-avatar">
                        <img src="assets/img/mark.png" alt="User Photo">
                    </div>
                    <div class="user-info">
                        <span class="user-name-sidebar">{{ userName }}</span>
                        <span class="user-role">Administrator</span>
                    </div>
                    <mat-icon class="user-menu-icon">unfold_more</mat-icon>
                </div>

                <mat-menu #sidenavProfileMenu="matMenu" class="sidenav-profile-menu">
                    <button mat-menu-item (click)="navigateToComponent('/home/profile')">
                        <mat-icon>person</mat-icon>
                        <span>View Profile</span>
                    </button>
                    <button mat-menu-item>
                        <mat-icon>settings</mat-icon>
                        <span>Account Settings</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="logout()" class="logout-btn">
                        <mat-icon>logout</mat-icon>
                        <span>Log out</span>
                    </button>
                </mat-menu>
            </div> -->
        </div>
    </mat-sidenav>

    <!-- Main Content Area -->
    <mat-sidenav-content class="main-content">
        <!-- Top Toolbar -->
        <mat-toolbar class="toolbar">
            <button class="menu-toggle" (click)="sidenav.toggle()">
                <mat-icon>menu</mat-icon>
            </button>

            <div class="toolbar-spacer"></div>

            <!-- Search Bar (Optional) -->
            <!-- <div class="toolbar-search">
                <mat-icon>search</mat-icon>
                <input type="text" placeholder="Search...">
            </div> -->

            <div class="toolbar-spacer"></div>

            <!-- Notification Bell -->
            <!-- <button class="toolbar-icon-btn" [matMenuTriggerFor]="notificationList">
                <mat-icon>notifications</mat-icon>
                <span class="notification-badge" *ngIf="notifications.length > 0">{{ notifications.length }}</span>
            </button> -->

            <!-- Profile Button -->
            <button class="toolbar-profile-btn" [matMenuTriggerFor]="profileMenu">
                <img [src]="profilePicture" alt="User Photo" class="toolbar-avatar">
                <mat-icon class="dropdown-arrow">expand_more</mat-icon>
            </button>

            <!-- Profile Menu -->
            <mat-menu #profileMenu="matMenu" class="profile-dropdown">
                <div class="profile-menu-header">
                    <img [src]="profilePicture" alt="User Photo" class="profile-menu-avatar">
                    <div class="profile-menu-info">
                        <span class="profile-menu-name">{{ userName }}</span>
                        <span class="profile-menu-email">{{ email }}</span>
                    </div>
                </div>
                <!-- <mat-divider></mat-divider>
                <button mat-menu-item>
                    <mat-icon>person</mat-icon>
                    <span>My Profile</span>
                </button>
                <button mat-menu-item>
                    <mat-icon>settings</mat-icon>
                    <span>Settings</span>
                </button>
                <button mat-menu-item>
                    <mat-icon>help_outline</mat-icon>
                    <span>Help & Support</span>
                </button>
                <mat-divider></mat-divider> -->
                <button mat-menu-item (click)="logout()" class="logout-menu-item">
                    <mat-icon>logout</mat-icon>
                    <span>Log out</span>
                </button>
            </mat-menu>

            <!-- Notifications Menu -->
            <mat-menu #notificationList="matMenu" class="notifications-dropdown">
                <div class="notifications-header">
                    <span class="notifications-title">Notifications</span>
                    <button class="mark-read-btn">Mark all as read</button>
                </div>
                <mat-divider></mat-divider>
                <div class="notifications-list">
                    @for (notification of notifications; track $index) {
                    <div class="notification-item">
                        <div class="notification-icon">
                            <mat-icon>notifications</mat-icon>
                        </div>
                        <div class="notification-content">
                            <span class="notification-title">{{ notification.title }}</span>
                            <span class="notification-text">{{ notification.content }}</span>
                            <span class="notification-time">{{ notification.time }}</span>
                        </div>
                    </div>
                    }
                </div>
                <mat-divider></mat-divider>
                <div class="notifications-footer">
                    <button class="view-all-btn">View All Notifications</button>
                </div>
            </mat-menu>
        </mat-toolbar>

        <!-- Page Content -->
        <div class="page-content">
            <router-outlet />
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
